import { render } from "./MonthEndView.vue?vue&type=template&id=228de4f6&scoped=true"
import script from "./MonthEndView.vue?vue&type=script&lang=js"
export * from "./MonthEndView.vue?vue&type=script&lang=js"

import "./MonthEndView.vue?vue&type=style&index=0&id=228de4f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228de4f6"]])

export default __exports__